import React from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./shared/routes/router";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./shared/theme/theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "./shared/components/snackbar/Snackbar";

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider>
      <RouterProvider router={router} />
      </SnackbarProvider>
    </ThemeProvider>
    </QueryClientProvider>


  );
}

export default App;
